import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  HistoryOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SaveOutlined,
  UpOutlined,
} from "@ant-design/icons";
import Highcharts from "highcharts";

import BoxContent from "@src/component/Desktop/content";
import { Button, Col, Collapse, Drawer, Modal, Row, Select, Tabs, Timeline, Typography } from "antd";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import "react-reflex/styles.css";
import { EquipmentApi } from "../../api/backend/equipment";
import { Apifacility } from "../../api/backend/facilityManagement";
import { default as KBN, default as kbn } from "../../api/backend/kbn";
import API from "../../api/backend/machineManagement";
import { usefulLifeApi } from "../../api/backend/usefulLife";
import Loading from "../../component/Desktop/loading/loading";
import TitlePage from "../../component/Desktop/titlePage";
import FooterPage from "../../component/footer/footerPage";
import SelectWithLabel from "../../component/FormInput/SelectWithLabel";
import Overlay from "../../component/Overlay/Overlay";
import {
  COMMON_CONSTANT,
  INPUT_TYPE,
  KEY,
  lang,
  MODE_SCREEN,
  REGEX_INPUT,
  UNIT_INPUT,
} from "../../constants/common.const";
import {
  handleCatchError,
  MSG_CATCH,
  renderOption,
  showMessage,
  statusRes,
} from "../../constants/utils";
import classDdl from "../../models/control/dropdownlist";
import classGrid from "../../models/control/grid";
import classText from "../../models/control/text";
import { collapsedSideBar, setWidthModalColTable } from "../../redux/sideBar";
import {
  filterEmptyDataSource,
  formatDecimal,
  formatNumber,
  formatNumberFloat,
  isEmptyData,
} from "../../utils/helper";
import { transformData } from "../../utils/treeFolder";
import ChartItem from "./chartItem";
import "./equipment.scss";
import EquipmentAttach from "./equipmentAttach";
import EquipmentContent from "./equipmentContent";
import EquipmentContentCanEditLabel from "./equipmentContentCanEditLabel";
import EquipmentContentTable from "./equipmentContentTable";
import EquipmentFoderTree from "./equipmentFolderTree";
import EquipmentImage from "./equipmentImage";
import EquipmentListItem from "./equipmentListItem";
import EquipmentMaintainceHistory from "./equipmentMaintainceHistory";
import EquipmentPrimeMover from "./equipmentPrimeMove";
import EquipmentRepairPlan from "./equipmentRepairPlan";
import EquipmentSpecs from "./equipmentSpecs";
import ListEquipment from "./listEquipment";
import ModalSelectCategory from "./modalSelectCategory";
import ModalSelectLocationInstall from "./modalSelectLocationInstall";
import { useLocation } from "react-router-dom";
import { TagVideoSelect } from "../../component/video/TagVideoSelect";
import { TagVideoList } from "../../component/video/TagVideoList";

import { VideoApi } from "../../api/backend/video";
const { TabPane } = Tabs;
const { Panel } = Collapse;
const EquipmentManage = () => {
  const query = new URLSearchParams(useLocation().search);
  const machineCode = query.get("code");
  // TRee MODE ADD
  const [addExpandKeyCategory, setAddExpandKeyCategory] = useState([]);
  const [addExpandKeyLocation, setAddExpandKeyLocation] = useState([]);
  const [addSelectKeyCategory, setAddSelectKeyCategory] = useState([]);
  const [addSelectKeyLocation, setAddSelectKeyLocation] = useState([]);

  // Defaut key
  const [deafaultExpadKeyCategory, setDefaultExpadKeyCategory] = useState(null);
  const [deafaultExpadKeyLocation, setDefaultExpadKeyLocation] = useState(null);
  const [deafaultSelectKeyCategory, setDefaultSelectKeyCategory] =
    useState(null);
  const [deafaultSelectKeyLocation, setDefaultSelectKeyLocation] =
    useState(null);

  const [imageUrl, setImageUrl] = useState("");
  const [listAttachMachine, setListAttachMachine] = useState([]);
  const [tags,setTags] = useState([]);
  const [listAllTag,setListAllTag] = useState([])

  const [clickSave, setClickSave] = useState(false);
  const [currentMachineSelect, setCurrentSelectMachine] = useState(null);
  const [mode, setMode] = useState(MODE_SCREEN.VIEW);
  const objectFilterOrigin = {
    areaTreatment: new classDdl(""),
    facility: new classDdl(""),
    category: new classDdl(""),
  };
  const [objFilter, setObjFilter] = useState(objectFilterOrigin);
  const overviewDataOrigin = {
    controlNumber: new classText(""), // 管理番号
    equipmentName: new classText(""), // 設備名称
    generationNumber: new classDdl(), // 世代番号
    equipmentCategory: new classText(""), // 設備分類
    installationLocation: new classText(""), // 設置場所
    installationDate: new classText(""), // 設置年月日
    incinerationStart: new classText(""), // 償却開始
    usefulLife: new classText(""), // 耐用年数
    elapsedYears: new classText(""), // 経過年数
    acquisitionPrice: new classText(""), // 取得価格,
    facilityName: new classDdl(""),
    replacementDisposalYear: new classText(""),
    drawingNumber: new classText(""),
    made: new classText(""),
    using: new classText(""),
    note: new classText(""),
    statusMachine: new classDdl(null, lang.MACHINE_STATUS_VALUE),
    enduranceYear: new classText(""),
    condition: new classText(""),

    standardUsefulLife: new classText(""),
    targetUsefulLife: new classText(""),
    seriNumber: new classText(""),
    equipmentClassification: new classText(""),
  };
  const primeMoverDataOrigin = {
    engineModel: new classText(""), // 型式
    enginePartNumber: new classText(""), // 型番
    engineManufacturer: new classText(""), // メーカー
    engineSerialNumber: new classText(""), // 製造番号
    enginePowerOutput: new classText(""), // 出力kW
    engineVoltage: new classText(""), // 電圧
    engineCurrent: new classText(""), // 電流
    enginePoleCount: new classText(""), // 極数
    engineSpeed: new classText(""), // 回転数
    engineSpeedControl: new classText(false), // 回転数制御有無
    engineDutyTime: new classText(""), // 定格時間
    engineInsulationClass: new classText(""), // 絶縁種別
    engineLubricant: new classText(""), // 潤滑油
    engineBearingNumber: new classText(""), // 軸受番号
    engineBrake: new classText(false), // ブレーキ有無
    listAuxiliaryEngine: [],
  };
  const assetInfoDataOrigin = {
    managementMethod: new classDdl(""),
    importanceLevel: new classText(""), // 重要度
    functionalityCondition: new classText(""), // 機能的
    physicalCondition: new classText(""), // 物理的
    auxiliaryEquipmentCondition: new classText(""), // 補機類
    priorityLevel: new classText(""), // 優先度,
    overallCondition: new classText(""),
  };
  const specificationDataOrigin = {
    modelNumber: new classText(), // 型式
    partNumber: new classText(), // 型番
    manufactureName: new classText(), // メーカー
    serialNumber: new classText(), // 製造番号
    dimensions: new classText(), // 寸法など
    capacity: new classText(), // 能力など,
    listSpecs: [],
  };

  const [dataListItem, setDataListItem] = useState([]);
  const [listMaintenance, setListMaintenance] = useState([]);
  const [listPlanMaintenance, setListPlanMaintenance] = useState([]);
  const [overviewData, setOverviewData] = useState(overviewDataOrigin);
  const [currentGene, setCurrentGene] = useState();
  const [primeMoverData, setPrimeMoverData] = useState(primeMoverDataOrigin);

  const [specificationData, setSpecificationData] = useState(
    specificationDataOrigin
  );
  const [equipmentAndAccessories, setEquipmentAndAccessories] = useState([]);
  const [partsAndConsumables, setPartsAndConsumables] = useState([]);
  const [assetInfoData, setAssetInfoData] = useState(assetInfoDataOrigin);

  const [facilityOption, setFacilityOption] = useState([]);
  const [optionMethod, setOptionMethod] = useState([]);

  const dispatch = useDispatch();
  const [listEquipment, setListEquipment] = useState(new classGrid());
  const [activeTab, setActiveTab] = useState(1);
  const [cateSelect, setCateSelect] = useState({
    value: "",
    label: "",
    order: "",
    class: "",
  });
  const [locationSelect, setLocationSelect] = useState({
    value: "",
    label: "",
  });

  // Chart Item state
  const [startDateChart, setStartDateChart] = useState("");
  const [endDateChart, setEndDateChart] = useState("");
  const [dataChart, setDataChart] = useState([]);
  const [isGetDataChart, setIsGetDataChart] = useState(false);
  const [listSelectChart, setListSelectChart] = useState([]);
  const [isFistCheck, setIsFirstCheck] = useState(false);


  // Data Tree
  const [categoryTreeData, setCategoryTreeData] = useState([]);
  const [locationTreeData, setLocationTreeData] = useState([]);
  const [currentCategoryFilterNode, setCurrentCategoryFilterNode] =
    useState(null);
  const [currentLocationFilterNode, setCurrentLocationFilterNode] =
    useState(null);

  // Data DETAIL
  const [detailMachine, setDetailMachine] = useState();

  const [loading, setLoading] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [ddlClassification, setDdlClassification] = useState(new classDdl());
  const [firstNodeFilter, setFirstNodeFilter] = useState();

  const { collapsed } = useSelector((state) => state.sideBar);
  const [triggerWidth, setTriggerWidth] = useState(false);

  // Check Cancel
  const [isDirty, setIsDirty] = useState(false);
  const [showDrawer,setShowDrawer] = useState(false)
  // reset chart tab
  const resetChartTab = () => {
    setStartDateChart("");
    setEndDateChart("");
    setDataChart([]);
    setIsGetDataChart(false);
    setListSelectChart([]);
    setIsFirstCheck(false)
  };

  // Ref
  const overviewRef = useRef({});
  const getRefByKey = (objRef, key) => (el) => (objRef.current[key] = el);

  const isLastVersion =
    currentGene &&
    currentGene ==
      Math.max(...overviewData.generationNumber.options.map((i) => i.key));

  // SELECT CATE
  const onOKSelectCate = async () => {
    try {
      if (
        cateSelect.value != null &&
        cateSelect.value != undefined &&
        cateSelect.value != ""
      ) {
        const newDataOverview = { ...overviewData };
        const isNotgetData = cateSelect.class == 9 || cateSelect.order == 0;
        if (isNotgetData) {
          newDataOverview.standardUsefulLife.value = "";
          newDataOverview.targetUsefulLife.value = "";
        } else {
          // CALL Api get USEFULIFE
          const res = await usefulLifeApi.getUsefulLifeByCategory({
            categoryId: cateSelect.value,
          });

          if (res && res.data) {
            newDataOverview.standardUsefulLife.value =
              res.data.standardUsefulLife || "";
            newDataOverview.targetUsefulLife.value =
              res.data.targetUsefulLife || "";
          } else {
            newDataOverview.standardUsefulLife.value = "";
            newDataOverview.targetUsefulLife.value = "";
          }
        }

        setOverviewData({
          ...newDataOverview,
          equipmentCategory: {
            ...overviewData.equipmentCategory,
            value: cateSelect.order == 0 ? null : cateSelect.value,
            label: cateSelect.label,
            order: cateSelect.order,
          },
        });

        setIsDirty(true);
      }
    } catch (error) {
      handleCatchError(true);
    }
  };
  // list data overview
  const listDataOverview = [
    {
      title: "設備名称",
      value: overviewData.equipmentName,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "equipmentName",
      required: true,
      refer: getRefByKey(overviewRef, "equipmentName"),
    },
    {
      title: "管理番号",
      value: overviewData.controlNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "controlNumber",
      disabled: true,
      customView: detailMachine
        ? currentGene &&
          currentGene !== 1 &&
          overviewData.controlNumber.value !== "" &&
          overviewData.controlNumber.value !== null &&
          overviewData.controlNumber.value !== undefined
          ? overviewData.controlNumber.value + "_" + currentGene
          : overviewData.controlNumber.value
        : "",
      refer: getRefByKey(overviewRef, "controlNumber"),
    },
    {
      title: "世代番号",
      value: overviewData.generationNumber,
      type: INPUT_TYPE.CUSTOM,
      rule: [],
      span: 1,
      key: "generationNumber",
      component: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: 10,
          }}
        >
          <Select
            className={`${mode !== MODE_SCREEN.VIEW ||
              (mode === MODE_SCREEN.VIEW && !currentMachineSelect) ? "equipment-disabled-input" :""}`}
            onChange={(v) =>
              handlechangeInput(overviewData, setOverviewData)(
                "generationNumber",
                v
              )
            }
            value={overviewData.generationNumber.value}
            disabled={
              mode !== MODE_SCREEN.VIEW ||
              (mode === MODE_SCREEN.VIEW && !currentMachineSelect)
            }
            style={{
              flex: 1,
             
            }}
          >
            {renderOption(overviewData.generationNumber.options, false)}
          </Select>
          {mode === MODE_SCREEN.VIEW && (
            <Button
              disabled={!currentMachineSelect}
              style={{
                minWidth: 40,
              }}
              onClick={() => viewGenerationMachine()}
              className="button-select buttonPC button--info --todo-- wAuto"
            >
              表示
            </Button>
          )}
        </div>
      ),
    },
    {
      titleModal: "設備分類選択",
      title: "設備分類",
      value: overviewData.equipmentCategory,
      type: INPUT_TYPE.MODAL,
      error:
        mode !== MODE_SCREEN.VIEW &&
        clickSave &&
        (overviewData.equipmentCategory.value === "" ||
          overviewData.equipmentCategory.value === undefined),
      rule: [],
      span: 1,
      key: "equipmentCategory",
      labelButton: "参照",
      disbaledButton: mode === MODE_SCREEN.UP,
      required: true,
      refer: getRefByKey(overviewRef, "equipmentCategory"),
      disabledSave: !cateSelect.value  ||  !cateSelect.label ||  cateSelect.haveChildren,
      onOk: () => {
        onOKSelectCate();
      },
      oncanCel: () => {
        setCateSelect({
          value: "",
          label: "",
          order: "",
        });
      },
      modalComponent: (
        <ModalSelectCategory
          setCategoryType={(type) =>
            setOverviewData({
              ...overviewData,
              equipmentClassification: {
                ...overviewData.equipmentClassification,
                value: type,
              },
            })
          }
          listSelects={addSelectKeyCategory}
          listExpands={addExpandKeyCategory}
          setListSelects={setAddSelectKeyCategory}
          setListExpands={setAddExpandKeyCategory}
          initFilter={objFilter.category}
          onSelect={(dataSelect) => {
            setCateSelect(dataSelect);
          }}
        />
      ),
    },
    {
      title: "施設名",
      value: overviewData.facilityName,
      type: INPUT_TYPE.SELECT,
      rule: [],
      span: 1,
      key: "facilityName",
      required: true,
      refer: getRefByKey(overviewRef, "facilityName"),
      haveEmptyOption: false,
      customChange: (newValue, item) => {
        setOverviewData({
          ...overviewData,
          installationLocation: {
            ...overviewData,
            installationLocation: overviewData.installationLocation,
            value: "",
            label: "",
          },
          facilityName: {
            ...overviewData.facilityName,
            value: newValue,
          },
        });
      },
    },
    {
      title: lang.SERI_NUMBER,
      value: overviewData.seriNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "seriNumber",
    },

    {
      title: lang.EQUIPMENT_STATUS,
      value: overviewData.statusMachine,
      type: INPUT_TYPE.SELECT,
      rule: [],
      span: 1,
      key: "statusMachine",
    },
    {
      titleModal: "設置場所選択",
      title: "設置場所",
      value: overviewData.installationLocation,
      type: INPUT_TYPE.MODAL,
      labelButton: "参照",
      disabledSave:!locationSelect.label || !locationSelect.value,
      rule: [],
      span: 2,
      key: "installationLocation",
      onOk: () => {
        setOverviewData({
          ...overviewData,
          installationLocation: {
            ...overviewData.installationLocation,
            value: locationSelect.value,
            label: locationSelect.label,
          },
        });
        setIsDirty(true);
      },
      oncanCel: () => {
        setLocationSelect({
          value: "",
          label: "",
        });
      },
      modalComponent: (
        <ModalSelectLocationInstall
          listSelects={addSelectKeyLocation}
          listExpands={addExpandKeyLocation}
          setListSelects={setAddSelectKeyLocation}
          setListExpands={setAddExpandKeyLocation}
          initFilter={overviewData.facilityName}
          onSelect={(dataSelect) => {
            setLocationSelect(dataSelect);
          }}
        />
      ),
    },

    {
      title: lang.DRAWING_NUMBER,
      value: overviewData.drawingNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "drawingNumber",
    },
    {
      title: lang.MADE,
      value: overviewData.made,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "made",
    },
    {
      title: "用途",

      value: overviewData.using,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "using",
    },
    {
      title: lang.CONDITION,

      value: overviewData.condition,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "condition",
    },
    {
      title: lang.NOTE,

      value: overviewData.note,
      type: INPUT_TYPE.AREA,
      rule: [],
      span: 2,
      key: "note",
    },
    {
      title: "設置年月日",
      value: overviewData.installationDate,
      type: INPUT_TYPE.DATE,
      rule: [],
      span: 1,
      key: "installationDate",
    },
    {
      title: "償却開始日",
      value: overviewData.incinerationStart,
      type: INPUT_TYPE.DATE,
      rule: [],
      span: 1,
      key: "incinerationStart",
      afterDate: moment().format(KEY.DATE_DEFAULT),
    },
    {
      title: lang.REPLACEMENT_DISPOSAL_YEAR,
      value: overviewData.replacementDisposalYear,
      type: INPUT_TYPE.DATE,
      rule: [],
      span: 1,
      key: "replacementDisposalYear",
    },

    {
      title: "経過年数",
      value: overviewData.elapsedYears,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.INT_10],
      span: 1,
      key: "elapsedYears",
      disabled: mode === MODE_SCREEN.UP,
      suffix: UNIT_INPUT.YEAR,
    },

    {
      title: "取得価格",
      value: overviewData.acquisitionPrice,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,10}$/],
      span: 1,
      key: "acquisitionPrice",
      suffix: UNIT_INPUT.YEN,
      onChangeCustom: (value) => {
        const raw = String(value).replace(/,/g, "");
        if (/^$|^\d{1,10}$/.test(raw)) {
          const num = raw === "" ? "" : Number(raw);
          setOverviewData({
            ...overviewData,
            acquisitionPrice: {
              ...overviewData.acquisitionPrice,
              value: formatNumber(num),
            },
          });
        }
      },
    },

    {
      title: "",
      value: "",
      suffix: UNIT_INPUT.YEN,
      isNone: true,
    },
    {
      title: "耐用年数",
      value: overviewData.usefulLife,
      type: INPUT_TYPE.LABEL,
      rule: [],
      span: 2,
      key: "usefulLife",
      hideTitle: true,
    },
    {
      title: lang.USEFUL_LIFE_STANDARD,
      value: overviewData.standardUsefulLife,
      type: INPUT_TYPE.LABEL,
      rule: [],
      span: 1,
      key: "standardUsefulLife",
      suffix: UNIT_INPUT.YEAR,
    },
    {
      title: lang.USEFUL_LIFE_TARGET,
      value: overviewData.targetUsefulLife,
      type: INPUT_TYPE.LABEL,
      rule: [],
      span: 1,
      key: "targetUsefulLife",
      suffix: UNIT_INPUT.YEAR,
    },

    {
      title: "メーカー推奨耐久年数",
      value: overviewData.enduranceYear,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.INT_10],
      span: 1,
      key: "enduranceYear",
      suffix: UNIT_INPUT.YEAR,
    },
    {
      title: "",
      value: "",
      suffix: UNIT_INPUT.YEN,
      isNone: true,
    },
    {
      title: lang.REF_VIDEO_TAG,
      value: <TagVideoList tags={tags || []} />,
      type: INPUT_TYPE.CUSTOM,
      span: 2,
      key: "tagLists",
      component:mode === MODE_SCREEN.VIEW ?<TagVideoList tags={tags || []} /> :<TagVideoSelect className={"w100"} listAll={listAllTag} tags={tags} setTags={setTags} />
    },
  ];
  // Data
  const listPrimeMover = [
    {
      title: "型式",
      value: primeMoverData.engineModel,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "engineModel",
    },
    {
      title: "型番",
      value: primeMoverData.enginePartNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "enginePartNumber",
    },
    {
      title: "メーカー",
      value: primeMoverData.engineManufacturer,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineManufacturer",
    },
    {
      title: "製造番号",
      value: primeMoverData.engineSerialNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineSerialNumber",
    },
    {
      title: "出力kW",
      value: primeMoverData.enginePowerOutput,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.DECIMAL_10_2],
      span: 1,
      key: "enginePowerOutput",
      isDecimal:2,
      customChange: ({target:{value}}) => {
        const raw = String(value).replace(/,/g, "");
        if (REGEX_INPUT.DECIMAL_10_2.test(raw)) {
          const num = raw === "" ? "" : raw;
          setPrimeMoverData({
            ...primeMoverData,
            enginePowerOutput: {
              ...primeMoverData.enginePowerOutput,
              value: formatNumberFloat(num),
            },
          });
        }
      },
    },
    {
      title: "電圧",
      value: primeMoverData.engineVoltage,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.DECIMAL_10_2],
      span: 1,
      key: "engineVoltage",
      isDecimal:2,
      customChange: ({target:{value}}) => {
        const raw = String(value).replace(/,/g, "");
        if (REGEX_INPUT.DECIMAL_10_2.test(raw)) {
          const num = raw === "" ? "" : raw;
          setPrimeMoverData({
            ...primeMoverData,
            engineVoltage: {
              ...primeMoverData.engineVoltage,
              value: formatNumberFloat(num),
            },
          });
        }
      },
    },
    {
      title: "電流",
      value: primeMoverData.engineCurrent,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.DECIMAL_10_2],
      span: 1,
      key: "engineCurrent",
      isDecimal:2,
      customChange: ({target:{value}}) => {
        const raw = String(value).replace(/,/g, "");
        if (REGEX_INPUT.DECIMAL_10_2.test(raw)) {
          const num = raw === "" ? "" : raw;
          setPrimeMoverData({
            ...primeMoverData,
            engineCurrent: {
              ...primeMoverData.engineCurrent,
              value: formatNumberFloat(num),
            },
          });
        }
      },
      
    },
    {
      title: "極数",
      value: primeMoverData.enginePoleCount,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.INT_10],
      span: 1,
      key: "enginePoleCount",
      customChange: ({target:{value}}) => {
        const raw = String(value).replace(/,/g, "");
        if (REGEX_INPUT.DECIMAL_10_2.test(raw)) {
          const num = raw === "" ? "" : raw;
          setPrimeMoverData({
            ...primeMoverData,
            enginePoleCount: {
              ...primeMoverData.enginePoleCount,
              value: formatNumber(num),
            },
          });
        }
      },
      
    },
    {
      title: "回転数",
      value: primeMoverData.engineSpeed,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineSpeed",
    },
    {
      title: "回転数制御有無",
      value: primeMoverData.engineSpeedControl,
      type: INPUT_TYPE.SWITCH,
      rule: [],
      span: 1,
      key: "engineSpeedControl",
    },
    {
      title: "定格時間",
      value: primeMoverData.engineDutyTime,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineDutyTime",
    },
    {
      title: "絶縁種別",
      value: primeMoverData.engineInsulationClass,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineInsulationClass",
    },
    {
      title: "潤滑油",
      value: primeMoverData.engineLubricant,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineLubricant",
    },
    {
      title: "軸受番号",
      value: primeMoverData.engineBearingNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineBearingNumber",
    },
    {
      title: "ブレーキ有無",
      value: primeMoverData.engineBrake,
      type: INPUT_TYPE.SWITCH,
      rule: [],
      span: 1,
      key: "engineBrake",
    },
  ];

  const listDataSpecification = [
    {
      title: "型式",
      value: specificationData.modelNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "modelNumber",
    },
    {
      title: "型番",
      value: specificationData.partNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "partNumber",
    },
    {
      title: "メーカー",
      value: specificationData.manufactureName,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "manufactureName",
    },
    {
      title: "製造番号",
      value: specificationData.serialNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "serialNumber",
    },
    {
      title: "寸法",
      value: specificationData.dimensions,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "dimensions",
    },
    {
      title: "能力",
      value: specificationData.capacity,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "capacity",
    },
  ];
  const handleAddRowMaintaince = (item) => {
    const key = Date.now();
    const newRow = {
      machineForSiteOfficeCode: "",
      dateImplementation: "",
      division: "",
      overview: "",
      workContent: "",
      contractor: "",
      ...(item || {}),
      listAttachment: [],
      key,
      id: null,
    };
    setListMaintenance([newRow, ...listMaintenance]);
  };
  const wrapTitlesWithSpan = (columns) =>
    columns.map((col) => ({
      ...col,
      title: <span style={{
        color:activeTab == col.key && "#fff",
        fontWeight:"bold"
      }} className="">{col.title}</span>,
    }));
  // TAB
  const listTab = [
    {
      title: "概要",
      component: (
        <div>
          <Row>
            <Col span={24}>
              <Row>
                <Col span={16}>
                  <EquipmentContent
                    handlechangeInput={handlechangeInput(
                      overviewData,
                      setOverviewData
                    )}
                    listData={listDataOverview.slice(0, 13)}
                    mode={mode}
                  />
                  <div className="mt20">
                    <EquipmentContent
                      handlechangeInput={handlechangeInput(
                        overviewData,
                        setOverviewData
                      )}
                      listData={listDataOverview.slice(13)}
                      mode={mode}
                    />
                  </div>
                </Col>
                <Col span={8}>
                  <Row>
                    <Col span={24}>
                      {" "}
                      <EquipmentImage
                        mode={mode}
                        imageUrl={imageUrl}
                        setImage={setImageUrl}
                        listAttachMachine={listAttachMachine}
                        setIsDirty={setIsDirty}
                      />
                    </Col>
                    <Col span={24}>
                      {" "}
                      <EquipmentAttach
                        mode={mode}
                        imageUrl={imageUrl}
                        setImageUrl={setImageUrl}
                        listAttachMachine={listAttachMachine}
                        setListAttachMachine={setListAttachMachine}
                        setIsDirty={setIsDirty}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      ),
      key: 1,
    },
    {
      title: "仕様",
      component: (
        <EquipmentSpecs
          handlechangeInput={handlechangeInput(
            specificationData,
            setSpecificationData
          )}
          listData={listDataSpecification}
          mode={mode}
          listSpecs={specificationData.listSpecs}
          setDataSpecs={setSpecificationData}
          specsData={specificationData}
          clickSave={clickSave}
          setIsDirty={setIsDirty}
        />
      ),

      //   <EquipmentContent
      //     handlechangeInput={handlechangeInput(
      //       specificationData,
      //       setSpecificationData
      //     )}
      //     listData={listDataSpecification}
      //     mode={mode}
      //   />
      // ),
      key: 2,
    },
    {
      title: "原動機",
      component: (
        <EquipmentPrimeMover
          handlechangeInput={handlechangeInput(
            primeMoverData,
            setPrimeMoverData
          )}
          listData={listPrimeMover}
          mode={mode}
          listAuxiliaryEngine={primeMoverData.listAuxiliaryEngine}
          setPrimeMoverData={setPrimeMoverData}
          primeMoverData={primeMoverData}
          clickSave={clickSave}
          setIsDirty={setIsDirty}
        />
      ),
      key: 3,
    },
    {
      title: "補機・付属品",
      component: (
        <EquipmentContentCanEditLabel
          handleChangeValueRow={handleChangeValueRow}
          handleAddRow={handleAddRow}
          handleDeleteRow={handleDeleteRow}
          data={equipmentAndAccessories}
          setData={setEquipmentAndAccessories}
          mode={mode}
          clickSave={clickSave}
          setIsDirty={setIsDirty}
        />
      ),
      key: 4,
    },
    {
      title: "部品・消耗品",
      component: (
        <EquipmentContentCanEditLabel
          handleChangeValueRow={handleChangeValueRow}
          handleAddRow={handleAddRow}
          handleDeleteRow={handleDeleteRow}
          data={partsAndConsumables}
          setData={setPartsAndConsumables}
          mode={mode}
          clickSave={clickSave}
          setIsDirty={setIsDirty}
        />
      ),
      key: 5,
    },
    {
      title: "アセット情報",
      component: (
        <EquipmentContentTable
          data={assetInfoData}
          setData={setAssetInfoData}
          mode={mode}
          setIsDirty={setIsDirty}
        />
      ),
      key: 6,
    },

    {
      title: lang.INSPECTION_ITEM,
      component: (
        <EquipmentListItem
          dataSource={dataListItem}
          setDataSource={setDataListItem}
          mode={mode}
          clickSave={clickSave}
          setIsDirty={setIsDirty}
          currentGene={currentGene}
        />
      ),
      key: 8,
    },
    {
      title: lang.MAINTAINCE_HISTORY_AND_PLAN,
      component: (
        <div>
          <h3 className="bold">{lang.MAINTAINCE_HISTORY}</h3>
          <EquipmentMaintainceHistory
            dataSource={listMaintenance}
            setDataSource={setListMaintenance}
            mode={mode}
            clickSave={clickSave}
            ddlClassification={ddlClassification}
            setDdlClassification={setDdlClassification}
            setIsDirty={setIsDirty}
            currentGene={currentGene}
          />
          <h3 className="bold mt20">{lang.REPAIR_PLAN}</h3>
          <EquipmentRepairPlan
            dataSource={listPlanMaintenance}
            setDataSource={setListPlanMaintenance}
            mode={mode}
            handleAddRowMaintaince={handleAddRowMaintaince}
            clickSave={clickSave}
            ddlClassification={ddlClassification}
            setDdlClassification={setDdlClassification}
            setIsDirty={setIsDirty}
            currentGene={currentGene}
          />
        </div>
      ),
      key: 9,
    },
    {
      title: "点検結果",
      component: (
        <ChartItem
          machineCode={
            detailMachine ? detailMachine.machineForSiteOfficeCode : ""
          }
          generationNumber={currentGene}
          startDateChart={startDateChart}
          setStartDateChart={setStartDateChart}
          endDateChart={endDateChart}
          setEndDateChart={setEndDateChart}
          dataChart={dataChart}
          setDataChart={setDataChart}
          isGetDataChart={isGetDataChart}
          setIsGetDataChart={setIsGetDataChart}
          activeTab={activeTab}
          listSelectChart={listSelectChart}
          setListSelectChart={setListSelectChart}
          checkResultID={detailMachine ? detailMachine.checkResultID : ""}
          detailMachine={detailMachine}
          isFistCheck={isFistCheck}
          setIsFirstCheck={setIsFirstCheck}
        />
      ),
      key: 7,
    },
  ];

  useEffect(() => {
    dispatch(collapsedSideBar(true));
  }, []);

  // CANCEL
  const handleCancel = () => {
    setListMaintenance([]);
    setListPlanMaintenance([]);
    setDataListItem([]);
    setMode(MODE_SCREEN.VIEW);
    setClickSave(false);
    if (currentMachineSelect) {
      handleSelectTable(currentMachineSelect, "cancel");
    } else {
      resetData();
    }
  };

  const onCancel = () => {
    if (isDirty) {
      Modal.confirm({
        centered: true,
        icon: <QuestionCircleOutlined />,
        title: lang.CONFIRM,
        content: COMMON_CONSTANT.BOM_C018,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        onOk: handleCancel,
      });
    } else {
      handleCancel();
    }
  };
  // VIEW GENE
  async function viewGenerationMachine() {
    try {
      setLoadingScreen(true);
      setCurrentGene(overviewData.generationNumber.value);
      const res = await EquipmentApi.getDetailByGeneration({
        machineForSiteOfficeCode: detailMachine
          ? detailMachine.machineForSiteOfficeCode
          : "",
        generation: overviewData.generationNumber.value,
      });
      if (res.status == 200) {
        setDetailMachine(res.data);
        setDataDetail(res.data);
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoadingScreen(false);
    }
  }
  // ADD
  const handleAdd = () => {
    setMode(MODE_SCREEN.ADD);
    resetDataAdd();
    setIsDirty(false);
  };

  // UP
  const handleUp = async () => {
    try {
      setLoadingScreen(true);
      let listCheckItem = [],
        listMain = [],
        listPlan = [];

      const res = await EquipmentApi.getDataCheckItemAndMaitain(
        detailMachine ? detailMachine.machineForSiteOfficeCode : ""
      );
      const dataInit = res.data || {};
      const { listMaintenance, listPlanMaintenance, checkItems } = dataInit;
      // Check Item
      listCheckItem = Array.isArray(checkItems)
        ? checkItems.map((item, index) => ({
            id: item.id,
            checkItemCode: item.checkItemCode || "",
            checkItemName: item.checkItemName || "",
            controlValueLow: item.lowerControlValue || "",
            controlValueUpper: item.upperControlValue || "",
            easyDriveLow: item.normalLowerControlValue || "",
            easyDriveUpper: item.normalUpperControlValue || "",
            inputFormat: item.mode || "",
            unit: item.unit || "",
            selection: item.choices || "",
            inspectionFryquency: item.inspectionTiming || "",
            isUsed: item.isUsed || false,
            key: index,
            generationNumber: item.generationNumber,
          }))
        : [];

      // Mantain
      listMain = Array.isArray(listMaintenance)
        ? listMaintenance.map((item, index) => ({
            id: item.id,
            machineForSiteOfficeCode: item.machineForSiteOfficeCode,
            dateImplementation: moment.unix(item.dateImplementation).toDate(),
            division: item.division,
            overview: item.overview,
            workContent: item.workContent,
            contractor: item.contractor,
            listAttachment: item.listAttachment.map((item, index) => ({
              ...item,
              key: index + 1,
            })),
            key: index + 1,
            contractorValue: item.contractorValue,
            repairFrequency: !item.repairFrequency
              ? "0"
              : String(item.repairFrequency),
            isUsed: item.isUsed || false,
            generationNumber: item.generationNumber,
          }))
        : [];

      // plan
      listPlan = Array.isArray(listPlanMaintenance)
        ? listPlanMaintenance.map((item) => ({
            generationNumber: item.generationNumber,
            id: item.id,
            machineForSiteOfficeCode: item.machineForSiteOfficeCode,
            dateImplementation: moment.unix(item.dateImplementation).toDate(),
            division: item.division,
            overview: item.overview,
            workContent: item.workContent,
            contractor: item.contractor,
            listAttachment: item.listAttachment,
            key: Math.random().toString(36).substring(2),
            contractorValue: item.contractorValue,
            repairFrequency: !item.repairFrequency
              ? "0"
              : String(item.repairFrequency),
          }))
        : [];
      let upControlNumber = overviewData.controlNumber.value;
      const newGeneValue =
        Number(
          Math.max(...overviewData.generationNumber.options.map((i) => i.value))
        ) + 1;
      const list = upControlNumber.split("_");
      // reset up
      setOverviewData({
        ...overviewDataOrigin,
        controlNumber: {
          ...overviewData.controlNumber,
          value: list[0] + "_" + newGeneValue,
        },

        generationNumber: {
          ...overviewData.generationNumber,
          value: newGeneValue,
        },

        elapsedYears: {
          ...overviewData.elapsedYears,
          value: dataInit.elapsedYears,
        },
        equipmentName: {
          ...overviewData.equipmentName,
          value: dataInit.machineForSiteOfficeName,
        },
        equipmentCategory: {
          ...overviewData.equipmentCategory,
          value: dataInit.machineClassificationMasterId,
          label: dataInit.equipmentList,
        },
        installationLocation: {
          ...overviewData.installationLocation,
          value: dataInit.installLocationId,
          label: dataInit.installLocationList,
        },
        acquisitionPrice: {
          ...overviewData.acquisitionPrice,
          value: formatNumber(dataInit.price),
        },
        facilityName: {
          ...overviewData.facilityName,
          options: facilityOption,
          value: dataInit.facilityCode,
        },
        equipmentClassification: {
          ...overviewData.equipmentClassification,
          value: dataInit.equipmentClassification,
        },
        targetUsefulLife: {
          ...overviewData.targetUsefulLife,
          value: dataInit.targetUsefulLife,
        },
        standardUsefulLife: {
          ...overviewData.standardUsefulLife,
          value: dataInit.standardUsefulLife,
        },
      });
      setEquipmentAndAccessories([]);
      setPartsAndConsumables([]);
      setPrimeMoverData(primeMoverDataOrigin);
      setAssetInfoData({
        ...assetInfoDataOrigin,
        managementMethod: {
          ...assetInfoDataOrigin.managementMethod,
          options: optionMethod,
        },
      });
      setSpecificationData(specificationDataOrigin);
      setEquipmentAndAccessories([]);
      setPartsAndConsumables([]);
      setListAttachMachine([]);
      setImageUrl("");
      setListMaintenance(listMain);
      setListPlanMaintenance(listPlan);
      setDataListItem(listCheckItem);
      setMode(MODE_SCREEN.UP);
      setIsDirty(false);
      setCurrentGene(newGeneValue);
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoadingScreen(false);
    }
  };

  // EDIT
  const handleEdit = () => {
    setIsDirty(false);
    setMode(MODE_SCREEN.EDIT);
    setOverviewData({
      ...overviewData,
      generationNumber: {
        ...overviewData.generationNumber,
        value: currentGene,
      },
      facilityName: {
        ...overviewData.facilityName,
        options: facilityOption,
      },
    });
    setAssetInfoData({
      ...assetInfoData,
      managementMethod: {
        ...assetInfoData.managementMethod,
        options: optionMethod,
      },
    });
  };

  const resetAfterActionAddAndDelete = async (mode) => {
    setMode(MODE_SCREEN.VIEW);
    setCurrentSelectMachine(null);
    resetChartTab();
    setDetailMachine(null);
    resetData();
    try {
      setLoadingScreen(true);
      let params = {
        facilityCode: objFilter.facility.value,
        installLocationId: currentLocationFilterNode
          ? currentLocationFilterNode.id
          : "",
        categoryId: currentCategoryFilterNode
          ? currentCategoryFilterNode.id
          : "",
      };
      if (
        mode === MODE_SCREEN.ADD &&
        !params.installLocationId &&
        !params.categoryId
      ) {
        setListEquipment({
          ...listEquipment,
          data: [],
          count: 0,
        });
        return;
      }
      const res = await EquipmentApi.searchTreeMachine(params);
      const data = res.data;
      setListEquipment({
        ...listEquipment,
        data: data.machineOutputDtos || [],
        count: (data.machineOutputDtos || []).length,
      });
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoadingScreen(false);
    }
  };
  const resetAfterActionEditAndReup = async () => {
    setMode(MODE_SCREEN.VIEW);
    resetChartTab();
    resetData();
    await getDetailMachine(
      detailMachine ? detailMachine.machineForSiteOfficeCode : ""
    );
  };
  //
  const resetAfterActionReup = async (newCode) => {
    try {
      setMode(MODE_SCREEN.VIEW);
      setLoadingScreen(true);
      await getApiKBn(newCode, "cancel");
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoadingScreen(false);
    }
  };
  // DELETE
  const handleDeleteMachine = async (code) => {
    const deleteFunc = async () => {
      try {
        setLoadingScreen(true);
        const responseDelete = await EquipmentApi.deleteEquipment(
          detailMachine ? detailMachine.machineForSiteOfficeCode : ""
        );
        if (statusRes(responseDelete)) {
          await resetAfterActionAddAndDelete();
          //success
          showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004);
        }
      } catch (err) {
        handleCatchError(err);
      } finally {
        setLoadingScreen(false);
      }
    };
    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      title: lang.DELETE,
      content: COMMON_CONSTANT.BOM_C001,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: deleteFunc,
      centered: true,
    });
  };
  // VALIDATE
  const validate = () => {
    let flagErr = false;
    let tab = "1";
    // Tab 8 - 修繕計画
    let listCheckPlan = JSON.parse(JSON.stringify(listPlanMaintenance));
    listCheckPlan = listCheckPlan
      .map(({ generationNumber, ...others }) => others)
      .filter(filterEmptyDataSource);
    listCheckPlan.forEach(
      ({ dateImplementation, overview, workContent, contractor }) => {
        if (
          isEmptyData(dateImplementation) ||
          isEmptyData(contractor) ||
          isEmptyData(overview) ||
          isEmptyData(workContent)
        ) {
          flagErr = true;
          tab = "9";
        }
      }
    );
    // Tab 8 - 保全履歴
    let listMaintenanceCheck = JSON.parse(JSON.stringify(listMaintenance));
    listMaintenanceCheck = listMaintenanceCheck.filter(
      ({ listAttachment, generationNumber, ...row }) =>
        filterEmptyDataSource(row) ||
        (Array.isArray(listAttachment) && listAttachment.length !== 0)
    );
    listMaintenanceCheck.forEach(
      ({ dateImplementation, contractor, overview, workContent }) => {
        if (
          isEmptyData(dateImplementation) ||
          isEmptyData(contractor) ||
          isEmptyData(overview) ||
          isEmptyData(workContent)
        ) {
          flagErr = true;
          tab = "9";
        }
      }
    );
    // Tab 7 - List Item - "点検項目"
    let listCheckItem = JSON.parse(JSON.stringify(dataListItem));
    listCheckItem = listCheckItem
      .map(({ generationNumber, ...others }) => others)
      .filter(filterEmptyDataSource);
    listCheckItem.forEach(
      ({ checkItemName, inspectionFryquency, inputFormat }) => {
        if (
          isEmptyData(checkItemName) ||
          isEmptyData(inspectionFryquency) ||
          isEmptyData(inputFormat)
        ) {
          flagErr = true;
          tab = "8";
        }
      }
    );
    // Tab 5 - 部品・消耗品
    partsAndConsumables.forEach((item) => {
      if (
        (isEmptyData(String(item.title.value).trim()) &&
          !isEmptyData(String(item.content.value).trim())) ||
        (!isEmptyData(String(item.title.value).trim()) &&
          isEmptyData(String(item.content.value).trim()))
      ) {
        flagErr = true;
        tab = "5";
      }
    });

    // Tab 4 - 補機・付属品
    equipmentAndAccessories.forEach((item) => {
      if (
        (isEmptyData(String(item.title.value).trim()) &&
          !isEmptyData(String(item.content.value).trim())) ||
        (!isEmptyData(String(item.title.value).trim()) &&
          isEmptyData(String(item.content.value).trim()))
      ) {
        flagErr = true;
        tab = "4";
      }
    });

    // Tab 3 - Prime mover
    primeMoverData.listAuxiliaryEngine.forEach((item) => {
      if (
        (isEmptyData(String(item.title.value).trim()) &&
          !isEmptyData(String(item.value.value).trim())) ||
        (!isEmptyData(String(item.title.value).trim()) &&
          isEmptyData(String(item.value.value).trim()))
      ) {
        flagErr = true;
        tab = "3";
      }
    });

    // TAB 2 - SPECS
    specificationData.listSpecs.forEach((item) => {
      if (
        (isEmptyData(String(item.title.value).trim()) &&
          !isEmptyData(String(item.value.value).trim())) ||
        (!isEmptyData(String(item.title.value).trim()) &&
          isEmptyData(String(item.value.value).trim()))
      ) {
        flagErr = true;
        tab = "2";
      }
    });

    // TAB 1 - OVERVIEW
    const overview = { ...overviewData };
    if (!overview.facilityName.value) {
      flagErr = true;
      overview.facilityName.error = true;
    }

    if (
      overview.equipmentCategory.value === "" ||
      overview.equipmentCategory.value === undefined
    ) {
      flagErr = true;
    }
    if (!overview.equipmentName.value) {
      flagErr = true;
      overview.equipmentName.error = true;
    } else {
      overview.equipmentName.error = false;
    }
    if (overview.facilityName.error) {
      if (overviewRef.current.facilityName) {
        tab = "1";
        overviewRef.current.facilityName.focus();
      }
    }
    if (overview.equipmentName.error) {
      if (overviewRef.current.equipmentName) {
        tab = "1";
        overviewRef.current.equipmentName.focus();
      }
    }
    // Handle FOCUS
    setOverviewData(overview);
    if (flagErr) {
      setActiveTab(tab);
    }
    return !flagErr;
  };
  // Popup common
  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    const callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      centered: true,
      icon: <QuestionCircleOutlined />,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };
  const formatDate = (date) => {
    return date ? moment(date).format(KEY.DATE_DEFAULT) : null;
  };
  const getEngineArray = (type, index) => {
    if (!primeMoverData.listAuxiliaryEngine[index]) {
      return "";
    }
    return primeMoverData.listAuxiliaryEngine[index][type].value;
  };
  const filterEmpty = (item, key1, key2) => {
    const val1 = item[key1] ? item[key1].value : "";
    const val2 = item[key2] ? item[key2].value : "";
    if (typeof val1 !== "string" || typeof val2 !== "string") return false;

    return !isEmptyData(String(val1.trim())) && !isEmptyData(val2.trim());
  };
  const getListMachineComponents = () => {
    const list1 = equipmentAndAccessories
      .filter((item) => filterEmpty(item, "title", "content"))
      .map((item, index) => ({
        type: 1,
        itemValue: item.content.value,
        itemName: item.title.value,
        displayOrder: index + 1,
      }));
    const list2 = partsAndConsumables
      .filter((item) => filterEmpty(item, "title", "content"))
      .map((item, index) => ({
        type: 2,
        itemValue: item.content.value,
        itemName: item.title.value,
        displayOrder: index + 1,
      }));
    const list3 = specificationData.listSpecs
      .filter((item) => filterEmpty(item, "title", "value"))
      .map((item, index) => ({
        type: 3,
        itemValue: item.value.value,
        itemName: item.title.value,
        displayOrder: index + 1,
      }));
    return [...list1, ...list2, ...list3];
  };

  const checkItemList = dataListItem
    .map(({ generationNumber, ...others }) => others)
    .filter(filterEmptyDataSource)
    .map((checkItem) => {
      const data = {
        checkItemCode: checkItem.checkItemCode,
        CheckItemName: checkItem.checkItemName,
        LowerControlValue: checkItem.controlValueLow,
        UpperControlValue: checkItem.controlValueUpper,
        NormalLowerControlValue: checkItem.easyDriveLow,
        NormalUpperControlValue: checkItem.easyDriveUpper,
        Mode: checkItem.inputFormat,
        Unit: checkItem.unit,
        Choices: checkItem.selection,
        InspectionTiming: checkItem.inspectionFryquency,
      };
      if (checkItem.id) data.id = checkItem.id;
      return data;
    });

  const submitListMaintenance = listMaintenance
    .filter((item) => {
      const arrayProps = Object.keys(item);
      return arrayProps.some((x) => {
        return x != "key" && x != "generationNumber" && !isEmpty(item[x]);
      });
    })
    .sort((a, b) => (a.dateImplementation > b.dateImplementation ? 1 : -1))
    .map((item) => {
      return {
        ID: item.id,
        MachineForSiteOfficeCode: item.machineForSiteOfficeCode,
        DateImplementation: moment(item.dateImplementation).unix(),
        Division: item.division,
        Overview: item.overview,
        WorkContent: item.workContent,
        Contractor: item.contractor,
        ListAttachment: item.listAttachment,
      };
    });

  const submitListPlanMaintenance = listPlanMaintenance
    .filter((item) => {
      const arrayProps = Object.keys(item);
      return arrayProps.some((x) => {
        return x != "key" && x != "generationNumber" && !isEmpty(item[x]);
      });
    })
    .map((item) => {
      return {
        ID: item.id,
        MachineForSiteOfficeCode: item.machineForSiteOfficeCode,
        DateImplementation: moment(item.dateImplementation).unix(),
        Division: item.division,
        Overview: item.overview,
        WorkContent: item.workContent,
        Contractor: item.contractor,
        RepairFrequency: item.repairFrequency,
      };
    });
  const submitListAttachment =
    listAttachMachine.length > 0
      ? listAttachMachine
          .filter((x) => x.type != 2)
          .map((x) => {
            if (x.attachFileName) return x;
            return {
              AttachFileName: x.name || x.attachFileName,
              Type: x.pomType || 1,
            };
          })
      : null;

    const getValueFormatPost =  (value) => {
      if(value === null || value === undefined)return "";
      return String(value).replace(/,/g, "")
    }
  // SAVE
  const onSaveData = async () => {
    try {
      setLoadingScreen(true);
      const body = {
        // Tab 1 - overview
        machineForSiteOfficeName: overviewData.equipmentName.value,
        facilityCode: overviewData.facilityName.value,

        sn: overviewData.seriNumber.value,
        status: overviewData.statusMachine.value,
        applyDate: formatDate(overviewData.installationDate.value),
        drawingLineItemNumber: overviewData.drawingNumber.value,
        saiban: overviewData.made.value,
        use: overviewData.using.value,
        enduranceYear: overviewData.enduranceYear.value,
        replacementDate: formatDate(overviewData.replacementDisposalYear.value),
        condition: overviewData.condition.value,
        note: overviewData.note.value,
        // situation: overviewData.statusMachine.value,
        imageUrl: imageUrl,
        generationNumber: overviewData.generationNumber.value,
        equipmentClassification: overviewData.equipmentClassification.value,
        machineClassificationMasterId: overviewData.equipmentCategory.value,
        depreciationStart: formatDate(overviewData.incinerationStart.value),
        elapsedYears: overviewData.elapsedYears.value,
        price: getValueFormatPost(overviewData.acquisitionPrice.value),
        installLocationId: overviewData.installationLocation.value,

        // Tab2 - specification - 仕様
        modelNumber: specificationData.modelNumber.value,
        partNumber: specificationData.partNumber.value,
        manufactureName: specificationData.manufactureName.value,
        serialNumber: specificationData.serialNumber.value,
        dimensions: specificationData.dimensions.value,
        capacity: specificationData.capacity.value,

        // Tab 3 - Privemover - 原動機
        engineModel: primeMoverData.engineModel.value,
        enginePartNumber: primeMoverData.enginePartNumber.value,
        engineManufacturer: primeMoverData.engineManufacturer.value,
        engineSerialNumber: primeMoverData.engineSerialNumber.value,
        enginePowerOutput:getValueFormatPost( primeMoverData.enginePowerOutput.value),
        engineVoltage: getValueFormatPost( primeMoverData.engineVoltage.value),
        engineCurrent: getValueFormatPost(primeMoverData.engineCurrent.value),
        enginePoleCount: getValueFormatPost(primeMoverData.enginePoleCount.value),
        engineSpeed: primeMoverData.engineSpeed.value,
        engineSpeedControl:
          primeMoverData.engineSpeedControl.value == true ? "1" : "0",
        engineDutyTime: primeMoverData.engineDutyTime.value,
        engineInsulationClass: primeMoverData.engineInsulationClass.value,
        engineLubricant: primeMoverData.engineLubricant.value,
        engineBearingNumber: primeMoverData.engineBearingNumber.value,
        engineBrake: primeMoverData.engineBrake.value == true ? "1" : "0",
        engineAddItem1Name: getEngineArray("title", 0),
        engineAddItem1Value: getEngineArray("value", 0),
        engineAddItem2Name: getEngineArray("title", 1),
        engineAddItem2Value: getEngineArray("value", 1),

        // Tab 4,5 補機・付属品 - 部品・消耗品
        listMachineComponents: getListMachineComponents(),

        // Tab 6  : アセット情報
        managementMethod: assetInfoData.managementMethod.value,
        priorityLevel: assetInfoData.priorityLevel.value,
        importanceLevel: assetInfoData.importanceLevel.value,
        overallCondition: assetInfoData.overallCondition.value,
        functionalityCondition: assetInfoData.functionalityCondition.value,
        physicalCondition: assetInfoData.physicalCondition.value,
        auxiliaryEquipmentCondition:
          assetInfoData.auxiliaryEquipmentCondition.value,
        customerAssetNumber: "",
        checkItems: checkItemList,
        listAttachment: submitListAttachment,
        listMaintenance: submitListMaintenance,
        listPlanMaintenance: submitListPlanMaintenance,
        tagLists:tags
      };

      // CALL API
      let newCode = "";
      let res;
      if (mode === MODE_SCREEN.ADD) {
        res = await EquipmentApi.createEquipment(body);

        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, () => {
          newCode = res.data.machineForSiteOfficeCode;
          resetAfterActionReup(newCode);
        });
      } else if (mode == MODE_SCREEN.EDIT) {
        body.machineForSiteOfficeCode = detailMachine
          ? detailMachine.machineForSiteOfficeCode
          : "";
        res = await EquipmentApi.updateEquipment(body);
        newCode = res.data.machineForSiteOfficeCode;
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, () => {
          resetAfterActionReup(newCode);
        });
      } else if (mode === MODE_SCREEN.UP) {
        body.machineForSiteOfficeCode = detailMachine
          ? detailMachine.machineForSiteOfficeCode
          : "";
        res = await EquipmentApi.upVersionEquipment(body);
        newCode = res.data.machineForSiteOfficeCode;
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, () => {
          resetAfterActionReup(newCode);
        });
      }
    } catch (error) {
      console.log(error);
      handleCatchError(error);
    } finally {
      setLoadingScreen(false);
    }
  };
  const handleSave = () => {
    setClickSave(true);
    if (!validate()) {
      return;
    }
    showConfirmMessage(COMMON_CONSTANT.BOM_C008, onSaveData);
  };

  // CHANGE INPUT
  function handlechangeInput(objData, setObjData = () => {}, isNotDirty) {
    return (key, value, rules = [], mode) => {
      if (Array.isArray(rules) && rules.length > 0) {
        const isValid = rules.every((rule) => rule.test(value));
        if (!isValid) {
          return;
        }
      }
      let newData = { ...objData[key], value };
      if (mode === MODE_SCREEN.DATE) {
        newData = {
          ...newData,
          valueString: moment(newData.value).format(KEY.DATE_DEFAULT),
        };
      }
      setObjData({
        ...objData,
        [key]: newData,
      });

      // Dirty
      if (!isNotDirty) {
        setIsDirty(true);
      }
    };
  }

  // reset default tree
  const resetDefaultTree = () => {
    setDefaultExpadKeyCategory([]);
    setDefaultExpadKeyLocation([]);
    setDefaultSelectKeyCategory([]);
    setDefaultSelectKeyLocation([]);
  };
  const resetTreeAdd = () => {
    setAddExpandKeyCategory([]);
    setAddExpandKeyLocation([]);
    setAddSelectKeyCategory([]);
    setAddSelectKeyLocation([]);
  };
  // Change Filter
  const handleChangeFilter = async (key, value) => {
    try {
      const newObjFilter = JSON.parse(JSON.stringify(objFilter));

      if (key === "areaTreatment") {
        let nameArea = "";
        const itemArea = objFilter.areaTreatment.options.find(
          (i) => i.key === value
        );
        if (itemArea) {
          nameArea = itemArea.value;
        }
        const resFacility = await Apifacility.searchNewFacility({
          processingArea: nameArea,
        });
        const dataFacility =
          resFacility.data.map((item) => ({
            key: item.facilityCode,
            value: item.facilityName,
          })) || [];

        newObjFilter.facility.options = dataFacility;
        if (Array.isArray(dataFacility) && dataFacility.length > 0) {
          newObjFilter.facility.value = dataFacility[0].key;
        } else {
          newObjFilter.facility.value = "";
        }
      }

      newObjFilter[key].value = value;

      setObjFilter(newObjFilter);
      resetDefaultTree();
      resetData();
      setCurrentSelectMachine(null);
      setDetailMachine(null);
      resetChartTab();
      await get2Tree({
        processingArea: newObjFilter.areaTreatment.value,
        facilityCode: newObjFilter.facility.value,
        machineClassificationName: newObjFilter.category.value,
      });
      // resetDefaultTree()
    } catch (error) {
      handleCatchError(error);
    }

    // CALL API SEARCH
  };
  // RESET
  function resetDataAdd(mode = MODE_SCREEN.ADD) {
    setClickSave(false);
    setTags([])
    setOverviewData({
      ...overviewDataOrigin,
      generationNumber: {
        ...overviewDataOrigin.generationNumber,
        value:
          mode === MODE_SCREEN.ADD
            ? "1"
            : overviewDataOrigin.generationNumber.value,
      },
      facilityName: {
        ...overviewDataOrigin.facilityName,
        value: objFilter.facility.value,
        options: facilityOption,
      },
    });
    setPrimeMoverData(primeMoverDataOrigin);
    setAssetInfoData({
      ...assetInfoDataOrigin,
      managementMethod: {
        ...assetInfoDataOrigin.managementMethod,
        options: optionMethod,
      },
    });
    setSpecificationData(specificationDataOrigin);
    setEquipmentAndAccessories([]);
    setPartsAndConsumables([]);
    setListAttachMachine([]);
    setImageUrl("");
    setListMaintenance([]);
    setListPlanMaintenance([]);
    setDataListItem([]);
  }
  function resetData(mode = MODE_SCREEN.ADD) {
    setClickSave(false);
    setOverviewData({
      ...overviewDataOrigin,
      facilityName: {
        ...overviewDataOrigin.facilityName,
        options: facilityOption,
      },
    });
    setPrimeMoverData(primeMoverDataOrigin);
    setAssetInfoData({
      ...assetInfoDataOrigin,
    });
    setSpecificationData(specificationDataOrigin);
    setEquipmentAndAccessories([]);
    setPartsAndConsumables([]);
    setListAttachMachine([]);
    setImageUrl("");
    setListMaintenance([]);
    setListPlanMaintenance([]);
    setDataListItem([]);
    resetTreeAdd();
  }

  // CALULATE DATE
  function calculateElapsedYears(dateInput) {
    if (!dateInput) return "";

    const inputDate = moment(dateInput);
    if (!inputDate.isValid()) return "";

    const now = moment();
    const diffDays = now.diff(inputDate, "days");

    if (diffDays <= 365) {
      return 1;
    } else {
      const years = Math.floor(diffDays / 365);
      return years;
    }
  }

  // ADD row
  function handleAddRow(data, setData) {
    setData([
      ...data,
      {
        key: Date.now(),
        content: new classText(),
        title: new classText(),
      },
    ]);
  }
  function handleDeleteRow(data, setData, key) {
    const newData = data.filter((i) => i.key != key);
    setData(newData);
  }
  function handleChangeValueRow(data, setData, key, field, value) {
    const newData = [...data];
    const indexItem = data.findIndex((i) => i.key == key);
    if (indexItem < 0) {
      return;
    }
    newData[indexItem][field].value = value;
    setData(newData);
  }

  useEffect(() => {
    if (mode !== MODE_SCREEN.VIEW && overviewData.incinerationStart.value) {
      const diffYear = calculateElapsedYears(
        overviewData.incinerationStart.value
      );
      handlechangeInput(
        overviewData,
        setOverviewData,
        true
      )("elapsedYears", diffYear);
    }
  }, [overviewData.incinerationStart.value]);
  useEffect(() => {
    if (listMaintenance.length === 0 && mode === MODE_SCREEN.ADD) {
      setListMaintenance([
        {
          key: Date.now(),
          machineForSiteOfficeCode: "",
          dateImplementation: "",
          division: "",
          overview: "",
          workContent: "",
          contractor: "",
          listAttachment: [],
          generationNumber: 1,
        },
      ]);
    }
  }, [listMaintenance, mode]);
  useEffect(() => {
    if (dataListItem.length === 0 && mode === MODE_SCREEN.ADD) {
      setDataListItem([
        {
          key: Date.now(),
          checkItemCode: "",
          checkItemName: "",
          controlValueLow: "",
          controlValueUpper: "",
          easyDriveLow: "",
          easyDriveUpper: "",
          inputFormat: "",
          unit: "",
          selection: "",
          inspectionFryquency: "",
          generationNumber: 1,
        },
      ]);
    }
  }, [dataListItem, mode]);
  useEffect(() => {
    if (listPlanMaintenance.length === 0 && mode === MODE_SCREEN.ADD) {
      setListPlanMaintenance([
        {
          key: Date.now(),
          machineForSiteOfficeCode: "",
          dateImplementation: "",
          division: "",
          overview: "",
          workContent: "",
          contractor: "",
          repairFrequency: "",
          generationNumber: 1,
        },
      ]);
    }
  }, [listPlanMaintenance, mode]);

  // INIT DATA SELECT

  const handleSelectTable = (node, type) => {
    if (mode !== MODE_SCREEN.VIEW && type != "cancel") {
      return;
    }
    setMode(MODE_SCREEN.VIEW);
    setCurrentSelectMachine(node);
    // setInitSelectData();
    getDetailMachine(node.machineForSiteOfficeCode);
    setFirstNodeFilter(null);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  function resetTreeFilter() {
    setCurrentCategoryFilterNode(null);
    setCurrentLocationFilterNode(null);
    setListEquipment({
      ...listEquipment,
      data: [],
      count: 0,
    });
  }

  const getNameStatus = (status) => {
    const statusItem = lang.MACHINE_STATUS_VALUE.find((i) => i.key == status);
    return statusItem ? statusItem.value : "";
  };
  // SET DATA DETAIL
  const setDataDetail = (data) => {
    if (!data) return;
    resetChartTab();
    const newOverviewData = { ...overviewData };

    // TAG
    setTags(data.tagLists || [])
    // --- Tab 1: Overview ---
    newOverviewData.controlNumber.value = data.machineForSiteOfficeCode;
    newOverviewData.equipmentName.value = data.machineForSiteOfficeName || "";
    newOverviewData.equipmentName.error = false;
    newOverviewData.facilityName.value = data.facilityCode || "";
    newOverviewData.facilityName.valueString = data.facilityName || "";
    newOverviewData.facilityName.error = false;
    newOverviewData.generationNumber.value = data.generationNumber;
    setCurrentGene(data.generationNumber);
    newOverviewData.generationNumber.options = data.generationVersion.map(
      (i) => ({
        value: i,
        key: i,
      })
    );

    newOverviewData.seriNumber.value = data.sn || "";
    newOverviewData.statusMachine.value = data.status
      ? Number(data.status)
      : "";
    newOverviewData.statusMachine.valueString = getNameStatus(data.status);
    newOverviewData.installationDate.value = data.applyDate
      ? moment(data.applyDate)
      : null;
    newOverviewData.installationDate.valueString = formatDate(data.applyDate);
    newOverviewData.drawingNumber.value = data.drawingLineItemNumber || "";
    newOverviewData.made.value = data.saiban || "";
    newOverviewData.using.value = data.use || "";
    newOverviewData.enduranceYear.value = data.enduranceYear || "";
    newOverviewData.replacementDisposalYear.valueString = formatDate(
      data.replacementDate
    );

    newOverviewData.replacementDisposalYear.value = data.replacementDate
      ? moment(data.replacementDate)
      : null;
    newOverviewData.condition.value = data.condition || "";
    newOverviewData.note.value = data.note || "";
    newOverviewData.generationNumber.value = data.generationNumber || "";
    newOverviewData.equipmentClassification.value =
      data.equipmentClassification || "";
    newOverviewData.equipmentCategory.value =
      data.machineClassificationMasterId || "";
    newOverviewData.equipmentCategory.label = data.equipmentList || "";
    newOverviewData.equipmentCategory.error = false;
    newOverviewData.incinerationStart.valueString = formatDate(
      data.depreciationStart
    );
    newOverviewData.incinerationStart.value = data.depreciationStart
      ? moment(data.depreciationStart)
      : null;

    newOverviewData.elapsedYears.value = data.elapsedYears || "";
    newOverviewData.acquisitionPrice.value = data.price
      ? formatNumber(data.price)
      : "";
    newOverviewData.installationLocation.value = data.installLocationId || "";
    newOverviewData.installationLocation.label = data.installLocationList || "";
    newOverviewData.standardUsefulLife.value = data.standardUsefulLife || "";
    newOverviewData.targetUsefulLife.value = data.targetUsefulLife || "";

    const newimageUrl = data.imageUrl || "";

    // --- Tab 2: Specification ---
    let newSpecificationDatawData = JSON.parse(
      JSON.stringify(specificationData)
    );
    newSpecificationDatawData.modelNumber.value = data.modelNumber || "";
    newSpecificationDatawData.partNumber.value = data.partNumber || "";
    newSpecificationDatawData.manufactureName.value =
      data.manufactureName || "";
    newSpecificationDatawData.serialNumber.value = data.serialNumber || "";
    newSpecificationDatawData.dimensions.value = data.dimensions || "";
    newSpecificationDatawData.capacity.value = data.capacity || "";

    // --- Tab 3: Prime Mover ---
    const newPrimeMoverDataData = JSON.parse(JSON.stringify(primeMoverData));
    newPrimeMoverDataData.engineModel.value = data.engineModel || "";
    newPrimeMoverDataData.enginePartNumber.value = data.enginePartNumber || "";
    newPrimeMoverDataData.engineManufacturer.value =
      data.engineManufacturer || "";
    newPrimeMoverDataData.engineSerialNumber.value =
      data.engineSerialNumber || "";
    newPrimeMoverDataData.enginePowerOutput.value =
    formatNumberFloat(formatDecimal(data.enginePowerOutput || "",2));
    newPrimeMoverDataData.engineVoltage.value =formatNumberFloat(formatDecimal( data.engineVoltage || "",2));
    newPrimeMoverDataData.engineCurrent.value = formatNumberFloat(formatDecimal(data.engineCurrent || "",2));
    newPrimeMoverDataData.enginePoleCount.value = formatNumber(data.enginePoleCount || "");
    newPrimeMoverDataData.engineSpeed.value = data.engineSpeed || "";
    newPrimeMoverDataData.engineSpeedControl.value =
      data.engineSpeedControl == 1 ? true : false;
    newPrimeMoverDataData.engineSpeedControl.valueString =
      data.engineSpeedControl == 1 ? lang.YES : lang.NO;
    newPrimeMoverDataData.engineDutyTime.value = data.engineDutyTime || "";
    newPrimeMoverDataData.engineInsulationClass.value =
      data.engineInsulationClass || "";
    newPrimeMoverDataData.engineLubricant.value = data.engineLubricant || "";
    newPrimeMoverDataData.engineBearingNumber.value =
      data.engineBearingNumber || "";
    newPrimeMoverDataData.engineBrake.value =
      data.engineBrake == 1 ? true : false;
    newPrimeMoverDataData.engineBrake.valueString =
      data.engineBrake == 1 ? lang.YES : lang.NO;

    // --- Prime Mover: Additional Engines (chỉ khi có Name) ---
    newPrimeMoverDataData.listAuxiliaryEngine = [];

    if (data.engineAddItem1Name) {
      newPrimeMoverDataData.listAuxiliaryEngine.push({
        title: { value: data.engineAddItem1Name },
        value: { value: data.engineAddItem1Value || "" },
        key: 1,
      });
    }

    if (data.engineAddItem2Name) {
      newPrimeMoverDataData.listAuxiliaryEngine.push({
        title: { value: data.engineAddItem2Name },
        value: { value: data.engineAddItem2Value || "" },
        key: 2,
      });
    }

    // --- Tab 4, 5: Components ---
    const newEquipmentAndAccessories = [];
    const newPartsAndConsumables = [];
    newSpecificationDatawData.listSpecs = [];
    if (Array.isArray(data.listMachineComponents)) {
      data.listMachineComponents.forEach((item, index) => {
        const obj = {
          title: { ...new classText(), value: item.itemName || "" },
          content: { ...new classText(), value: item.itemValue || "" },
          value: { ...new classText(), value: item.itemValue || "" },
          key: item.type + " " + index,
        };
        if (item.type == 1) newEquipmentAndAccessories.push(obj);
        else if (item.type == 2) newPartsAndConsumables.push(obj);
        else if (item.type == 3) newSpecificationDatawData.listSpecs.push(obj);
      });
    }

    // --- Tab 6: Asset Info ---
    const newAssetInfoData = JSON.parse(JSON.stringify(assetInfoData));

    newAssetInfoData.managementMethod.value = data.managementMethod || "";
    newAssetInfoData.managementMethod.valueString =
      data.managementMethodValue || "";
    newAssetInfoData.priorityLevel.value = data.priorityLevel || "";
    newAssetInfoData.importanceLevel.value = data.importanceLevel || "";
    newAssetInfoData.overallCondition.value = data.overallCondition || "";
    newAssetInfoData.functionalityCondition.value =
      data.functionalityCondition || "";
    newAssetInfoData.physicalCondition.value = data.physicalCondition || "";
    newAssetInfoData.auxiliaryEquipmentCondition.value =
      data.auxiliaryEquipmentCondition || "";

    // --- Check Items ---
    let newDataListItem = JSON.parse(JSON.stringify(dataListItem));
    newDataListItem = Array.isArray(data.checkItems)
      ? data.checkItems.map((item, index) => ({
          id: item.id,
          checkItemCode: item.checkItemCode || "",
          checkItemName: item.checkItemName || "",
          controlValueLow: item.lowerControlValue || "",
          controlValueUpper: item.upperControlValue || "",
          easyDriveLow: item.normalLowerControlValue || "",
          easyDriveUpper: item.normalUpperControlValue || "",
          inputFormat: item.mode || "",
          unit: item.unit || "",
          selection: item.choices || "",
          inspectionFryquency: item.inspectionTiming || "",
          isUsed: item.isUsed || false,
          key: index,
          generationNumber: item.generationNumber,
        }))
      : [];

    // --- Maintenance ---
    let newlistMaintenance = JSON.parse(JSON.stringify(listMaintenance));

    newlistMaintenance = Array.isArray(data.listMaintenance)
      ? data.listMaintenance.map((item, index) => ({
          generationNumber: item.generationNumber,
          id: item.id,
          machineForSiteOfficeCode: item.machineForSiteOfficeCode,
          dateImplementation: moment.unix(item.dateImplementation).toDate(),
          division: item.division,
          overview: item.overview,
          workContent: item.workContent,
          contractor: item.contractor,
          listAttachment: item.listAttachment.map((item, index) => ({
            ...item,
            key: index + 1,
          })),
          key: index + 1,
          contractorValue: item.contractorValue,
          repairFrequency: !item.repairFrequency
            ? "0"
            : String(item.repairFrequency),
        }))
      : [];

    let newlistPlanMaintenance = JSON.parse(
      JSON.stringify(listPlanMaintenance)
    );

    newlistPlanMaintenance = Array.isArray(data.listPlanMaintenance)
      ? data.listPlanMaintenance.map((item) => ({
          generationNumber: item.generationNumber,
          id: item.id,
          machineForSiteOfficeCode: item.machineForSiteOfficeCode,
          dateImplementation: moment.unix(item.dateImplementation).toDate(),
          division: item.division,
          overview: item.overview,
          workContent: item.workContent,
          contractor: item.contractor,
          listAttachment: item.listAttachment,
          key: Math.random().toString(36).substring(2),
          contractorValue: item.contractorValue,
          repairFrequency: !item.repairFrequency
            ? "0"
            : String(item.repairFrequency),
        }))
      : [];

    // --- Attachments ---
    let newlistAttachMachine = JSON.parse(JSON.stringify(listAttachMachine));
    newlistAttachMachine = Array.isArray(data.listAttachment)
      ? data.listAttachment.map((x) => ({
          attachFileName: x.attachFileName,
          type: x.type,
          key: Math.random().toString(36).substring(2),
          attachFileUrl: x.attachFileUrl,
        }))
      : [];

    // Update State
    setOverviewData(newOverviewData);
    setSpecificationData(newSpecificationDatawData);
    setPrimeMoverData(newPrimeMoverDataData);
    setEquipmentAndAccessories(newEquipmentAndAccessories);
    setPartsAndConsumables(newPartsAndConsumables);
    setAssetInfoData(newAssetInfoData);
    setDataListItem(newDataListItem);
    setListMaintenance(newlistMaintenance);
    setListPlanMaintenance(newlistPlanMaintenance);
    setListAttachMachine(newlistAttachMachine);
    setImageUrl(newimageUrl);
  };
  // API GET DETAIL
  async function getDetailMachine(code) {
    try {
      setLoadingScreen(true);
      const res = await EquipmentApi.getDetailEquipment(code);
      if (res.status == 200) {
        setDetailMachine(res.data);
        setDataDetail(res.data);
      }
    } catch (error) {
      console.log(error);
      handleCatchError(error);
    } finally {
      setLoadingScreen(false);
    }
  }
  function findNodePathById(tree, targetId, path = []) {
    for (let node of tree) {
      const currentPath = [...path, node];
      if (node.id == targetId) {
        return currentPath;
      }
      if (node.children) {
        const result = findNodePathById(node.children, targetId, currentPath);
        if (result) return result;
      }
    }
    return null; // Không tìm thấy
  }
  // CALL API get tree location and tree categiro
  async function get2Tree(params, init, dataInit = {}, type) {
    try {
      const res = await EquipmentApi.get2TreeSelect(params);
      const data = res.data;
      const categoryData = data.machineClassificationHierarchyDtos || [];
      const locationData = data.installLocationHierarchyDTOs || [];
      setCategoryTreeData(categoryData);
      setLocationTreeData(locationData);
      if (dataInit.machineCode && init) {
        const locationId = dataInit.locationId;
        const categoryId = dataInit.categoryId;
        const cateTree = transformData(categoryData, "", []);
        const locationTree = transformData(locationData, "", []);
        const listPathCate = findNodePathById(cateTree, categoryId);
        let currentNodeCate, currentNodeLocation;
        if (Array.isArray(listPathCate) && listPathCate.length) {
          const selectNode = listPathCate.pop();
          setDefaultExpadKeyCategory(listPathCate.map((i) => i.key));
          setDefaultSelectKeyCategory([selectNode.key]);
          currentNodeCate = selectNode;
          setCurrentCategoryFilterNode(selectNode);
        } else {
          setDefaultExpadKeyCategory([]);
          setDefaultSelectKeyCategory([]);
        }
        if (locationId) {
          const listPathLocation = findNodePathById(locationTree, locationId);

          if (Array.isArray(listPathLocation) && listPathLocation.length) {
            const selectNode = listPathLocation.pop();
            setDefaultExpadKeyLocation(listPathLocation.map((i) => i.key));
            setDefaultSelectKeyLocation([selectNode.key]);
            currentNodeLocation = selectNode;
            setCurrentLocationFilterNode(selectNode);
          } else {
            setDefaultExpadKeyLocation([]);
            setDefaultSelectKeyLocation([]);
          }
        } else {
          setDefaultExpadKeyLocation([]);
          setDefaultSelectKeyLocation([]);
        }

        // Cal api
        let params = {
          facilityCode: dataInit.facilityCode,
          installLocationId: currentNodeLocation ? currentNodeLocation.id : "",
          categoryId: currentNodeCate ? currentNodeCate.id : "",
        };
        const res = await EquipmentApi.searchTreeMachine(params);
        const data = res.data.machineOutputDtos || [];
        const currentMachine = data.find(
          (ma) => ma.machineForSiteOfficeCode == dataInit.machineCode
        );
        if (currentMachine) {
          setListEquipment({
            ...listEquipment,
            data: data,
            count: data.length,
          });
          handleSelectTable(currentMachine, type);
        }
      } else {
        resetTreeFilter();
      }
    } catch (error) {
      handleCatchError(error);
    }
  }

  // CALL API SEARCH MACHINE
  async function searchTreeMachine(params, type = "") {
    try {
      setLoading(true);
      const res = await EquipmentApi.searchTreeMachine(params);
      const data = res.data;
      if (type === "category") {
        setLocationTreeData(data.installLocationHierarchyDTOs || []);
      }
      const dataList = data.machineOutputDtos || [];
      setListEquipment({
        ...listEquipment,
        data: data.machineOutputDtos || [],
        count: (data.machineOutputDtos || []).length,
      });
      if (dataList.length > 0) {
        handleSelectTable(dataList[0]);
      } else {
        setCurrentSelectMachine(null);
        setDetailMachine(null);
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  }

  const selectTreeFilter = async (node, type) => {
    let params = {
      facilityCode: objFilter.facility.value,
      installLocationId: "",
      categoryId: "",
    };
    if (type === "category") {
      setCurrentCategoryFilterNode(node);
      params.categoryId = node.id;
      setDefaultExpadKeyLocation([]);
      setDefaultSelectKeyLocation([]);
      setCurrentLocationFilterNode(null);
    } else {
      setCurrentLocationFilterNode(node);
      params.installLocationId = node.id;
      params.categoryId = currentCategoryFilterNode
        ? currentCategoryFilterNode.id
        : "";
    }
    resetData();
    resetChartTab();
    setDetailMachine(null);
    searchTreeMachine(params, type);
  };

  function clearQueryAndReload() {
    const baseUrl = window.location.origin + window.location.pathname;
    window.location.href = baseUrl;
  }
  // Call API

  const getApiKBn = async (code, type) => {
    try {
      setLoadingScreen(true);
      const notFoundErr = {
        status: 404,
      };
      const machineCodeFinal = code || machineCode
      let detail;
      setLoading(true);
      if (machineCodeFinal) {
        const resDetail = await EquipmentApi.getDetailEquipment(
          machineCodeFinal
        );
        if (resDetail.status != 200) {
          throw notFoundErr;
        } else {
          detail = resDetail.data;
          detail.area = detail.areaName;
          detail.areaCode = detail.areaId;
        }
      }
      const isInitMachine = machineCodeFinal && detail;
      const [cateRes, processArea] = await Promise.all([
        KBN.getCategoryMachine2(),
        KBN.getProcessArea(),
      ]);
      const newObjectFilter = JSON.parse(JSON.stringify(objFilter));
      const areaData = processArea.data.data || [];
      const cateData = cateRes.data.data || [];

      newObjectFilter.category.options = cateData;
      newObjectFilter.areaTreatment.options = areaData;
      let initAreaData = "";
      let initFacility = "";
      let initCategory = "";

      if (Array.isArray(areaData) && areaData.length > 0) {
        if (isInitMachine) {
          if (!areaData.find((i) => i.value == detail.area)) {
            // throw notFoundErr;
          }
          initAreaData = detail.area;
        } else {
          initAreaData = areaData[0].value;
        }
        newObjectFilter.areaTreatment.value = !isInitMachine
          ? areaData[0].key
          : detail.areaCode;
      }

      const resFacility = await Apifacility.searchNewFacility({
        processingArea: initAreaData,
      });
      const dataFacility =
        resFacility.data.map((item) => ({
          key: item.facilityCode,
          value: item.facilityName,
        })) || [];

      newObjectFilter.facility.options = dataFacility;

      if (Array.isArray(dataFacility) && dataFacility.length > 0) {
        if (isInitMachine) {
          if (!dataFacility.find((i) => i.key == detail.facilityCode)) {
            throw notFoundErr;
          }
          initFacility = detail.facilityCode;
        } else {
          initFacility = dataFacility[0].key;
        }
        newObjectFilter.facility.value = initFacility;
      }
      if (Array.isArray(cateData) && cateData.length > 0) {
        if (isInitMachine) {
          if (!cateData.find((i) => i.key == detail.equipmentClassification)) {
            // throw notFoundErr;
          }
          initCategory = detail.equipmentClassification;
        } else {
          initCategory = cateData[0].key;
        }
        newObjectFilter.category.value = initCategory;
      }
      setObjFilter(newObjectFilter);
      await get2Tree(
        {
          processingArea: newObjectFilter.areaTreatment.value,
          facilityCode: initFacility,
          machineClassificationName: initCategory,
        },
        true,
        {
          locationId: detail ? detail.installLocationId : "",
          categoryId: detail ? detail.machineClassificationMasterId : "",
          facilityCode: initFacility,
          machineCode: machineCodeFinal,
        },
        type
      );
    } catch (error) {
      const axiosError404 = error.response && error.response.status === 404;
      if (error.status === 404 || axiosError404) {
        showMessage(KEY.ERROR, MSG_CATCH(), clearQueryAndReload);
      } else {
        handleCatchError(error);
      }
    } finally {
      setLoadingScreen(false);
      setLoading(false);
    }
  };
  useEffect(() => {
    getApiKBn();
  }, []);

  const getDatafacility = async () => {
    try {
      const resFacility = await Apifacility.searchNewFacility({});
      const dataFacility =
        resFacility.data.map((item) => ({
          key: item.facilityCode,
          value: item.facilityName,
        })) || [];
      setFacilityOption(dataFacility);
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getDatafacility();
  }, []);
  const getListTag = async () => {
    try {
      const res = await VideoApi.getListTag({});
     setListAllTag(res.data)
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getListTag();
  }, []);

  const fetchClassification = async (value) => {
    try {
      const res = await API.getClassification();
      if (res && !isEmpty(res.data)) {
        setDdlClassification({
          ...ddlClassification,
          options: res.data.map((item) => ({
            ...item,
            label: item.classification,
            value: item.id,
          })),
        });
      }
    } catch (e) {}
  };
  useEffect(() => {
    fetchClassification();
  }, []);

  const getDataManagementMethod = async () => {
    try {
      const resFacility = await kbn.getManagementMethod({});
      const dataOption = resFacility.data.data || [];
      // setAssetInfoData({
      //   ...assetInfoData,
      //   managementMethod: {
      //     ...assetInfoData.managementMethod,
      //     options: dataOption,
      //   },
      // });
      setOptionMethod(dataOption);
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getDataManagementMethod();
  }, []);

  // Focus First Node filter
  useEffect(() => {
    if (firstNodeFilter && mode === MODE_SCREEN.VIEW) {
      handleSelectTable(firstNodeFilter);
    } else if (firstNodeFilter === undefined) {
      resetData();
      setDetailMachine(null);
      resetChartTab();
      setCurrentSelectMachine(null);
    }
  }, [firstNodeFilter]);
  const isShowTreeCate = machineCode
    ? deafaultExpadKeyCategory && deafaultSelectKeyCategory
      ? true
      : false
    : true;
  const isShowTreeLocation = machineCode
    ? deafaultExpadKeyLocation && deafaultSelectKeyLocation
      ? true
      : false
    : true;

      const dataTableChangeLog = (detailMachine && detailMachine.listHistory || []).map(
        (history, index) => {
          return {
            ...history,
            key: index,
            changeDate: moment(history.updateDatetime * 1000).format(
              "YYYY/MM/DD HH:mm"
            ),
            updateContent: history.updateDetail,
            updater: history.userUpdate,
            listAttachment: history.listAttachment
              .filter((x) => x.type == 2)
              .map((item, index) => {
                return {
                  ...item,
                  ItemOrder: 1,
                  FileName: item.attachFileName,
                  DotName: "PNG",
                  Description: item.description,
                  attachmentUrl: item.attachFileUrl,
                };
              }),
          };
        }
      );

// GET WIDTH
  const divRef = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      if (divRef.current) {
        const width = divRef.current.getBoundingClientRect().width;
        dispatch(
          setWidthModalColTable({
            key: "equipment",
            value: width,
          })
        );
      }
    }, 0);
  }, [collapsed, triggerWidth]);

  return (
    <div  className="des-content customFontSize">
      <TitlePage name={lang.DEVICE_SPECIFIC_LEDGER} />
      <Overlay top={-200} />

      <ReflexContainer orientation="vertical" style={{ height: "100%" }}>
        {/* LEFT PANE */}
        <ReflexElement
          onStopResize={() => {
            const chart = Highcharts.charts.find(
              (c) => c && c.renderTo && c.renderTo.id === "chart-equipment-info"
            );
            requestAnimationFrame(() => {
              chart && chart.reflow();
            });
            setTimeout(() => {
              chart && chart.reflow();
            }, 100);

            setTriggerWidth(!triggerWidth);
          }}
          flex={0.33}
          minSize={0}
          maxSize={window.innerWidth}
        >

          <div
            ref={divRef}
            className="equipment-tree-detail "
            style={{
              padding: 8,
              height: "100%",
              overflow: "auto",
              marginTop: -10,
            }}
          >
            <h3 className="bold ml10 ">設備選択</h3>
            <Row gutter={[16, 16]}>
              {/* === Filter === */}
              <Col span={24}>
                <BoxContent style={{ padding: "8px", margin: "8px" }}>
                  <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
                    <Panel
                      header={<span className="bold customFontSize">{lang.FILTER}</span>}
                      key="1"
                    >
                      <SelectWithLabel
                        disabled={mode !== MODE_SCREEN.VIEW}
                        value={objFilter.areaTreatment.value}
                        className="w100 mb10"
                        label={"処理区"}
                        options={objFilter.areaTreatment.options}
                        onChange={(e) => handleChangeFilter("areaTreatment", e)}
                        fontSize={16}
                        allTitle={true}
                      />
                      <SelectWithLabel
                        disabled={mode !== MODE_SCREEN.VIEW}
                        showSearch
                        value={objFilter.facility.value}
                        className="w100 mb10"
                        label={"施設"}
                        options={objFilter.facility.options}
                        hasEmptyvalue={false}
                        onChange={(e) => handleChangeFilter("facility", e)}
                      />
                      <SelectWithLabel
                        disabled={mode !== MODE_SCREEN.VIEW}
                        value={objFilter.category.value}
                        className="w100"
                        label={lang.TYPE_OF_WORK}
                        options={objFilter.category.options}
                        hasEmptyvalue={false}
                        onChange={(e) => handleChangeFilter("category", e)}
                      />
                    </Panel>
                  </Collapse>
                </BoxContent>
              </Col>

              {/* === Category Tree === */}
              <Col span={24}>
                <BoxContent style={{ padding: "8px", margin: "8px" }}>
                  <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
                    <Panel
                      header={
                        <span className="bold customFontSize">{lang.EQUIPMENT_CATEGORY}</span>
                      }
                      key="1"
                    >
                      {isShowTreeCate && (
                        <EquipmentFoderTree
                          currentKey={objFilter.areaTreatment.value}
                          listExpands={deafaultExpadKeyCategory}
                          setListExpands={setDefaultExpadKeyCategory}
                          listSelects={deafaultSelectKeyCategory}
                          setListSelects={setDefaultSelectKeyCategory}
                          disabled={loading || mode !== MODE_SCREEN.VIEW}
                          onSelect={(node) =>
                            selectTreeFilter(node, "category")
                          }
                          data={transformData(
                            categoryTreeData,
                            "",
                            deafaultExpadKeyCategory || [],16
                          )}
                        />
                      )}
                    </Panel>
                  </Collapse>
                </BoxContent>
              </Col>

              {/* === Location Tree === */}
              <Col span={24}>
                <BoxContent style={{ padding: "8px", margin: "8px" }}>
                  <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
                    <Panel
                      header={
                        <span className="bold customFontSize">{lang.EQUIPMENT_LOCATION}</span>
                      }
                      key="1"
                    >
                      {isShowTreeLocation && (
                        <EquipmentFoderTree
                          listExpands={deafaultExpadKeyLocation}
                          listSelects={deafaultSelectKeyLocation}
                          setListExpands={setDefaultExpadKeyLocation}
                          setListSelects={setDefaultSelectKeyLocation}
                          disabled={loading || mode !== MODE_SCREEN.VIEW}
                          onSelect={(node) =>
                            selectTreeFilter(node, "location")
                          }
                          data={transformData(
                            locationTreeData,
                            "",
                            deafaultExpadKeyLocation || [],16
                          )}
                        />
                      )}
                    </Panel>
                  </Collapse>
                </BoxContent>
              </Col>

              {/* === List Equipment === */}
              <Col span={24}>
                <BoxContent style={{ padding: "12px", margin: "8px" }}>
                  <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
                    <Panel
                      header={<span className="bold customFontSize">設備一覧</span>}
                      key="1"
                    >
                      <ListEquipment
                        currentNode={currentMachineSelect}
                        setCurrentNode={handleSelectTable}
                        data={listEquipment}
                        setFirstNodeFilter={setFirstNodeFilter}
                      />
                    </Panel>
                  </Collapse>
                </BoxContent>
              </Col>
            </Row>
          </div>
        </ReflexElement>

        {/* RESIZER */}
        <ReflexSplitter propagate={true} />

        {/* RIGHT PANE */}
        <ReflexElement>
          <div
            className="equipment-tree-detail"
            style={{
              padding: 10,
              height: "calc(100vh - 120px)",
              paddingBottom: 40,
              paddingTop: 0,
            }}
          >
            <h3 className="bold" style={{}}>
              設備情報
            </h3>

            <div
              style={{
                background: "#fff",
                padding: 10,
              }}
            >
              <Tabs
                destroyInactiveTabPane
                className=" tab-equipment-custom"
                activeKey={activeTab + ""}
                onChange={(key) => setActiveTab(key)}
                type="card"
              >
                {wrapTitlesWithSpan(listTab).map((tab) => (
                  <Tabs.TabPane tab={tab.title} key={tab.key} closable={false}>
                    <div style={{ overflowX: "auto" }}>{tab.component}</div>
                  </Tabs.TabPane>
                ))}
              </Tabs>
            </div>
          </div>
        </ReflexElement>
      </ReflexContainer>

      {/* Footer */}

      {activeTab !== "7" && (
        <FooterPage>
          {mode === MODE_SCREEN.VIEW ? (
            <Row justify="end">
              <Col>
              
              <Button
               disabled={!detailMachine}
                type="primary"
                className="buttonPC button--info wAuto"
                onClick={() => setShowDrawer(true)}
              >
                <HistoryOutlined />
                {lang.CHANGE_LOG}
              </Button></Col>
              <Col>
                <Button
                  disabled={!detailMachine}
                  onClick={handleUp}
                  className="buttonPC button--info wAuto ml10"
                >
                  <UpOutlined />
                  {lang.GENERATION_UPDATE}
                </Button>
                <Button
                  disabled={loading}
                  onClick={handleAdd}
                  className="buttonPC button--info wAuto ml10"
                >
                  <PlusOutlined />
                  {lang.ADD}
                </Button>
              </Col>
              <Col>
                <Button
                  disabled={!detailMachine || !isLastVersion}
                  onClick={handleEdit}
                  className="buttonPC button--outline --todo-- wAuto ml10"
                >
                  <EditOutlined />
                  {lang.EDIT}
                </Button>
              </Col>
              
              <Col>
                <Button
                  disabled={!detailMachine}
                  onClick={handleDeleteMachine}
                  className={`buttonPC  button--outline --todo-- ${
                    detailMachine && "button--error--outline"
                  } ml10`}
                >
                  <DeleteOutlined />
                  {lang.DELETE}
                </Button>
              </Col>
            </Row>
          ) : (
            <>
              <Row justify="end">
                <Col>
                  <Button
                    onClick={handleSave}
                    className="buttonPC button--info wAuto ml10"
                  >
                    <SaveOutlined />
                    {lang.SAVE}
                  </Button>
                </Col>
                <Col>
                  <Button
                    onClick={onCancel}
                    className="buttonPC button--outline --todo-- wAuto ml15"
                  >
                    <CloseCircleOutlined />
                    {lang.CANCEL}
                  </Button>
                </Col>
              </Row>
            </>
          )}
        </FooterPage>
      )}
       <Drawer
        title={lang.CHANGE_LOG}
        width={335}
        placement="right"
        onClose={() => setShowDrawer(false)}
        open={showDrawer === true}
        getContainer={false}
        visible={showDrawer === true}
      >
        <Timeline mode={"left"}>
          {dataTableChangeLog.map((item, index) => {
            const label =  (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`/HistoryUpdateEquipment?code=${detailMachine?detailMachine.machineForSiteOfficeCode :""}&version=${item.recordVersion}&generationNumber=${item.generationNumber}`}
              >
                <Typography.Text>{item.changeDate}</Typography.Text>
                <br />
              </a>
            )
            const dot = 
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={`/HistoryUpdateEquipment?code=${detailMachine?detailMachine.machineForSiteOfficeCode :""}&version=${item.recordVersion}&generationNumber=${item.generationNumber}`}
              >
                <HistoryOutlined />
              </a>
            
            return (
              <Timeline.Item
                key={index}
                label={label}
                dot={dot}
                style={{ cursor: "pointer",marginTop:-7 }}
              >
               
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    // href={`/HistoryUpdateMachine/${id}/${item.recordVersion}`}
                  >
                    <Typography.Title level={5}>
                      {item.updater}
                    </Typography.Title>
                    
                  </a>
                
              </Timeline.Item>
            );
          })}
        </Timeline>
      </Drawer>
      <Loading show={loadingScreen} />
    </div>
  );
};

export default EquipmentManage;
